import { Paquete } from '../../types/catalogo';

interface Props {
  paquetes: Paquete[];
  paqueteSeleccionadoId?: string;
  onSeleccionar: (paqueteId: string) => void;
}

export function PackageSelector({ paquetes, paqueteSeleccionadoId, onSeleccionar }: Props) {
  return (
    <div className="flex gap-3 flex-wrap">
      {paquetes.map((paquete) => {
        const seleccionado = paquete.id === paqueteSeleccionadoId;
        return (
          <button
            key={paquete.id}
            onClick={() => onSeleccionar(paquete.id)}
            data-testid={`package-selector-option-${paquete.id}`}
            className={`min-w-[110px] flex flex-col gap-0.5 rounded-lg px-5 py-3.5 text-left ${
              seleccionado
                ? 'border-2 border-terracotta bg-terracotta/10'
                : 'border-[1.5px] border-border'
            }`}
          >
            <span className="text-[13px] font-semibold">{paquete.nombre}</span>
            <span className="text-[15px] font-bold text-ink">S/ {paquete.precio.toFixed(2)}</span>
          </button>
        );
      })}
    </div>
  );
}
